import { REDUX_ACTIONS } from '../../shared/config/constants';

const initialState = {
  loading: false,
  deleting: false,
  data: [],
  errorMessage: '',
  loadingDelete: false,
  saved: false,
  paginatedElements: 0,
  disableAdd: false
};

const companyReducer = (state = initialState, action) => {
  switch (action.type) {
    case REDUX_ACTIONS.COMPANIES_LIST_LOADING:
      return {
        ...state,
        loading: true,
        errorMessage: ''
      };
    case REDUX_ACTIONS.COMPANIES_LIST_CLEAR:
      return {
        ...state,
        data: []
      };
    case REDUX_ACTIONS.COMPANIES_LIST_SUCCESS:
      return {
        ...state,
        loading: false,
        data: [...action.payload.companies],
        paginatedElements: action.payload.paginatedElements,
        errorMessage: ''
      };
    case REDUX_ACTIONS.COMPANIES_LIST_ERROR:
      return {
        ...state,
        loading: false,
        errorMessage: action.payload.message,
        data: []
      };
    case REDUX_ACTIONS.COMPANIES_LIST_ERROR_NOTIFIED:
      return {
        ...state,
        errorMessage: '',
        data: []
      };
    case REDUX_ACTIONS.COMPANIES_RESET:
      return {
        ...initialState
      };
    case REDUX_ACTIONS.COMPANIES_ADD_DISABLE: {
      return {
        ...state,
        disableAdd: action.payload
      };
    }
    default:
      return state;
  }
};

export default companyReducer;
